import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Button from '@mui/material/Button';
import { Link as RouterLink } from 'react-router-dom';

const pages = ['Home', 'Projects', 'Contact'];

export default function MenuAppBar() {
  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="static">
        <Toolbar sx={{ justifyContent: 'center' }}>
          {pages.map((page) => (
            <Button
              key={page}
              component={RouterLink}
              to={page === 'Home' ? '/' : `/${page.toLowerCase()}`}
              sx={{ m: 1, color: 'white', display: 'block' }}
            >
              {page}
            </Button>
          ))}
        </Toolbar>
      </AppBar>
    </Box>
  );
}
